module.exports = __webpack_public_path__ + "img/selo-gptw.ef1fd131.png";